<template>
  <div id="blog" class="blog-wrap pt-100 pb-75">
    <div class="container">
      <div class="row">
        <div class="col-lg-8 offset-lg-2">
          <div class="section-title style1 text-center mb-40">
            <span>Blog &amp; News</span>
            <h2>Read Our Latest News & Articles</h2>
          </div>
        </div>
      </div>

      <div class="row justify-content-center">
        <div
          class="col-xl-4 col-lg-6 col-md-6"
          v-for="blog in blogs"
          :key="blog.id"
        >
          <div class="blog-card style2">
            <div class="blog-img"><img :src="blog.image" alt="Image" /></div>
            <div class="blog-info">
              <ul class="blog-metainfo list-style">
                <li>
                  <i class="ri-user-add-line"></i>
                  <a href="#">{{ blog.user }}</a>
                </li>
                <li>
                  <i class="ri-calendar-check-fill"></i>
                  <a href="#">12 Mar, 2022</a>
                </li>
              </ul>
              <h3>
                <router-link to="/blog-details">
                  {{ blog.title }}
                </router-link>
              </h3>
              <p>{{ blog.shortDesc }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from "vue";

export default defineComponent({
  name: "LatestNews",
  data: () => ({
    blogs: [
      {
        id: 1,
        image: require("../../assets/images/blog/blog-4.jpg"),
        user: "Admin",
        date: "29 June, 2023",
        title: "Whatever You Do, Make Sure It Leads You To Happy Life",
        shortDesc:
          "Lorem Ipsum is simply dummy text of the and standard dummy text ever since when.",
      },
      {
        id: 2,
        image: require("../../assets/images/blog/blog-5.jpg"),
        user: "Admin",
        date: "28 June, 2023",
        title: "The Day I'd Spent At The Square Medical Facility Center",
        shortDesc:
          "Lorem Ipsum is simply dummy text of the and standard dummy text ever since when.",
      },
      {
        id: 3,
        image: require("../../assets/images/blog/blog-6.jpg"),
        user: "Admin",
        date: "27 June, 2023",
        title: "How Does Science Help In Dental Surgery Research",
        shortDesc:
          "Lorem Ipsum is simply dummy text of the and standard dummy text ever since when.",
      },
    ],
  }),
});
</script>